import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route, UrlSegment, UrlTree } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import decode from 'jwt-decode';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard  {

    constructor(
        private router: Router,
        public auth: AuthenticationService
    ) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // console.log('🚀 ~ file: auth.guard.ts ~ line 16 ~ AuthGuard ~ canLoad ~ route', route);
    // console.log('🚀 ~ file: auth.guard.ts ~ line 16 ~ AuthGuard ~ canLoad ~ segments', segments);
    // return true;
    // throw new Error('Method not implemented.');
    const api_key = localStorage.getItem('api_key');
    let userData: any;

    if (api_key > '') {
        console.log (api_key);
        try {
            userData = decode(api_key);
        } catch {
            this.router.navigate(['/login'], { queryParams: { returnUrl: '/' + route.path } });
            return false;
        }
        this.auth.user = userData;
        // console.log(userData);
        if (typeof userData.id !== 'undefined') {
            return true;
        } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: '/' + route.path } });
            return false;
        }
    } else {
        console.log('not api_key??');
    }

    return false;

  }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const api_key = localStorage.getItem('api_key');
        let userData: any;

        if (api_key > '') {
            console.log (api_key);
            try {
                userData = decode(api_key);
            } catch {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            this.auth.user = userData;
            // console.log(userData);
            if (typeof userData.id !== 'undefined') {
                return true;
            } else {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
        } else {
            console.log('not api_key??');
        }

        return false;

//         if (localStorage.getItem('user') > '') {
//             // logged in so return true
//             return true;
//         }

//         // not logged in so redirect to login page with the return url
//         this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
//         return false;
    }

    // canLoad(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // }

}
